"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBannerStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useBannerStore = (0, pinia_1.defineStore)('bannerStore', {
    state: () => ({
        loading: false,
        banners: [],
        totalBanners: 0,
        bannerFiles: [],
        bannerFilesLoading: false
    }),
    getters: {},
    actions: {
        getRandomBanners(router, query) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_banners_api', query: query }).href)
                    .then((response) => {
                    let banners = [];
                    if (Array.isArray(response['hydra:member'])) {
                        const ind = Math.floor(Math.random() * response['hydra:member'].length);
                        banners.push(Object.values(response['hydra:member'])[ind]);
                    }
                    this.banners = banners;
                    this.loading = false;
                    this.totalBanners = response['hydra:totalItems'];
                    resolve(response);
                })
                    .catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        getBanners(router, query) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_banners_api', query: query }).href)
                    .then((response) => {
                    let banners = [];
                    if (Array.isArray(response['hydra:member'])) {
                        response['hydra:member'].forEach(element => {
                            banners.push(element);
                        });
                    }
                    this.banners = banners;
                    this.loading = false;
                    this.totalBanners = response['hydra:totalItems'];
                    resolve(response);
                })
                    .catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        reset() {
            this.banners = [];
            this.totalBanners = 0;
        },
        resetBannerFiles() {
            this.bannerFiles = [];
            this.bannerFilesLoading = false;
        },
        createBanner(router, bannerRequest) {
            this.loading = true;
            let options = { body: JSON.stringify(bannerRequest), method: 'POST' };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_banners_api' }).href, options).then(response => {
                    this.loading = false;
                    resolve(response);
                }).catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        updateBanner(router, bannerRequest, id) {
            this.loading = true;
            let options = { body: JSON.stringify(bannerRequest), method: 'PATCH' };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_banners_api', params: { id: id } }).href, options).then(response => {
                    this.loading = false;
                    resolve(response);
                }).catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        deleteBanner(router, id) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: 'admin_banners_api', params: { id: id } }).href, { method: 'DELETE' })
                    .then(response => {
                    this.loading = false;
                    resolve();
                }).catch(error => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        async getActiveBannerFiles(router, query) {
            this.loading = true;
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'api_banner_files_active', query }).href);
                return response;
            }
            finally {
                this.loading = false;
            }
        },
        async getBannerFiles(router, params = {}) {
            this.bannerFilesLoading = true;
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'admin_banner_files_api', query: params }).href);
                const bannerFiles = [];
                if (Array.isArray(response['hydra:member'])) {
                    response['hydra:member'].forEach(element => {
                        if (element['@type'] !== 'BannerFile') {
                            return;
                        }
                        bannerFiles.push(element);
                    });
                }
                this.bannerFiles = bannerFiles;
                return response;
            }
            catch (error) {
                console.error('Error fetching banner files:', error);
                throw error;
            }
            finally {
                this.bannerFilesLoading = false;
            }
        },
        async saveBannerFile(router, formData) {
            this.bannerFilesLoading = true;
            const options = { method: 'POST', body: formData };
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'admin_banner_files_api' }).href, options);
                return response;
            }
            catch (error) {
                console.error('Error saving banner file:', error);
                throw error;
            }
            finally {
                this.bannerFilesLoading = false;
            }
        },
        async deleteBannerFile(router, bannerFile) {
            this.bannerFilesLoading = true;
            try {
                await (0, fetch_1.default)(router.resolve({ name: 'admin_banner_files_api', params: { id: Number(bannerFile.id) } }).href, { method: 'DELETE' });
            }
            catch (error) {
                console.error('Error deleting banner file:', error);
                throw error;
            }
            finally {
                this.bannerFilesLoading = false;
            }
        },
    },
});
